import React, { useEffect, useState } from 'react';
import { useNavVisibility, useScrollSpy } from './useNavbar';
import logo from './zdjecia/Inne/logo.png';

// Kolejność linków w pasku (desktop) i w panelu mobilnym — wspólne źródło.
const LINKS = [
  { id: 'sklep', label: 'Sklep', href: '#sklep' },
  { id: 'pasieka', label: 'Pasieka', href: '#pasieka' },
  { id: 'kontakt', label: 'Kontakt', href: '#kontakt' },
  { id: 'galeria', label: 'Galeria', href: '#galeria' },
];
const SECTION_IDS = LINKS.filter((link) => link.id !== 'galeria').map((link) => link.id);

const NavLink = ({ link, active, className, onClick }) => (
  <a
    href={link.href}
    className={`${className} ${active ? 'navbar__link--active' : ''}`}
    aria-current={active ? 'true' : undefined}
    onClick={onClick}
  >
    {link.label}
  </a>
);

// Stały pasek nawigacji: ukryty przy sekcji hero oraz przy scrollowaniu w dół,
// pojawia się przy scrollowaniu w górę (poza hero) — zob. useNavbar.
// Na wąskich ekranach menu rozwija się z góry w panel z przyciemnieniem tła.
const Navbar = React.memo(function Navbar({ view }) {
  const visible = useNavVisibility(view);
  const activeId = useScrollSpy(SECTION_IDS, view);
  const [open, setOpen] = useState(false);

  // Escape zamyka rozsunięte menu.
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (event) => {
      if (event.key === 'Escape') setOpen(false);
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open]);

  // Schowanie paska (scroll w dół) zwija też menu mobilne — po przewinięciu
  // w górę pasek wraca czysty, do rozłożenia przez navbar__toggle.
  useEffect(() => {
    if (!visible) setOpen(false);
  }, [visible]);

  const closeMenu = () => setOpen(false);

  return (
    <header className={`navbar ${visible ? 'navbar--visible' : ''} ${open ? 'navbar--open' : ''}`}>
      <a href="#strona" className="navbar__brand" onClick={closeMenu}>
        <img src={logo} alt="Przytulna Pasieka" className="navbar__logo" />
      </a>

      <nav className="navbar__links" aria-label="Nawigacja główna">
        {LINKS.map((link) => (
          <NavLink key={link.id} link={link} active={activeId === link.id} className="navbar__link" />
        ))}
      </nav>

      <button
        type="button"
        className="navbar__toggle"
        aria-expanded={open}
        aria-controls="navbar-panel"
        aria-label={open ? 'Zamknij menu' : 'Otwórz menu'}
        onClick={() => setOpen((value) => !value)}
      >
        <span className="navbar__burger" aria-hidden="true" />
      </button>

      <div className="navbar__backdrop" aria-hidden="true" onClick={closeMenu} />
      <nav id="navbar-panel" className="navbar__panel" aria-label="Nawigacja mobilna">
        {LINKS.map((link) => (
          <NavLink
            key={link.id}
            link={link}
            active={activeId === link.id}
            className="navbar__panel-link"
            onClick={closeMenu}
          />
        ))}
      </nav>
    </header>
  );
});

export default Navbar;